import React from "react"
import PropTypes from "prop-types"
import ReactTableVendor, {ReactTableDefaults} from "react-table"

import id from "@irati/utils/id"
import connect from "@irati/store/connect"
import {greys} from "@irati/ui/src/global/colors"

import {ReactTablePagination, ReactTableLoading} from "../index"

export const PB_PROP_RIGHT = "pbRight"
export const PB_PROP_CENTER = "pbCenter"
export const PB_LAST_COLUMN = "pbLastColumn"
export const DEFAULT_PAGE_SIZE = 20
export const TD_STYLE = {
  minWidth: "100px",
  maxWidth: "none",
  whiteSpace: "normal"
}
/** sync from Label3, not sure how to achieve this without duping? */
export const TH_STYLE = {
  textAlign: "left",
  outline: "none",
  fontFamily: "WorkSansMedium, sans-serif",
  textTransform: "uppercase",
  fontSize: "10px",
  lineHeight: "12px",
  letterSpacing: "0.6px",
  border: "none",
  color: greys.mediumDark,
  minWidth: "20px",
  maxWidth: "none",
  whiteSpace: "normal"
}

const TABLE_STYLE = {
  border: "none"
}
const THEAD_STYLE = {
  boxShadow: "none"
}
const TR_STYLE = {
  borderBottomColor: greys.light
}
const defaultTableProps = {
  minRows: 0,
  showPagination: true,
  defaultPageSize: DEFAULT_PAGE_SIZE,
  manual: true,
  multiSort: false,
  nextText: ">",
  previousText: "<",
  resizable: false,
  column: {
    ...ReactTableDefaults.column,
    style: TD_STYLE,
    headerStyle: TH_STYLE
  }
}

const _applyPbTextAlignment = (col) => {
  const style = {}
  if (!col) return style
  if (col[PB_PROP_CENTER]) style.textAlign = "center"
  if (col[PB_PROP_RIGHT]) style.textAlign = "right"
  if (!style.textAlign) style.textAlign = "left"
  return style
}

/**  */
export const applyPbPadding = (row, col, isPhone) => {
  /** default padding */
  let padding = ["20px", "40px", "20px", "0"]

  /** Return no padding overrides */
  if (!col) return {}

  if (!isPhone && col[PB_LAST_COLUMN]) padding = ["20px", "0", "20px", "0"]
  if (isPhone) {
    padding = col[PB_LAST_COLUMN] ? ["10px", "0", "10px", "0"] : ["10px", "10px", "10px", "0"]
  }

  /** header override, slim padding */
  if (!row) {
    padding[0] = "10px"
    padding[2] = "10px"
  }

  return {padding: padding.join(" ")}
}

export const getDefaultPropStyles = (row, col, isPhone) => {
  return {
    style: {
      ..._applyPbTextAlignment(col),
      ...applyPbPadding(row, col, isPhone)
    }
  }
}

const ReactTable = ({isPhone, ...props}) => {
  const idNamespace = id("ReactTable", props)
  return (
    <ReactTableVendor
      {...defaultTableProps}
      style={TABLE_STYLE}
      getTheadProps={() => ({style: THEAD_STYLE})}
      getTrGroupProps={() => ({style: TR_STYLE})}
      getTheadThProps={(state, row, col) => getDefaultPropStyles(row, col, isPhone)}
      getTdProps={(state, row, col) => getDefaultPropStyles(row, col, isPhone)}
      getPaginationProps={() => ({id: id("pagination", idNamespace)})}
      PaginationComponent={ReactTablePagination}
      LoadingComponent={ReactTableLoading}
      NoDataComponent={() => null}
      {...props} />
  )
}

ReactTable.propTypes = {
  isPhone: PropTypes.bool.isRequired
}

const mapStateToProps = ({mq}) => ({
  isPhone: mq.lessThan.medium
})
export default connect(mapStateToProps)(ReactTable)
